// The company header every service but the backend reads (banking, accounting, agent, ...).
export const COMPANY_HEADER = 'company-id';

// The backend alone reads 'companyid'. A request with no apiType goes to the backend too.
export const getCompanyHeaderName = (apiType) =>
  apiType && apiType !== 'backend' ? COMPANY_HEADER : 'companyid';

/**
 * The company header a request should carry, as `[name, value]`, or `null` to leave it alone.
 *
 * `storedCompanyId` is the selection in localStorage, which the interceptor otherwise applies to
 * every request. A header the caller already set wins over it. The KYC window relies on that: it
 * pins the company it was opened for, because the stored selection can move under an open form (a
 * boot fallback, a 403 fallback, another tab) and a legal person must never be created on whichever
 * company happens to be selected at submit time.
 */
export const resolveCompanyHeader = ({apiType, storedCompanyId, headers = {}}) => {
  const name = getCompanyHeaderName(apiType);
  if (headers[name]) return null;
  if (!storedCompanyId) return null;
  return [name, storedCompanyId];
};
